import React, { Component, PropTypes } from 'react';

import css from './checkbox.scss';

export default class InputMultiCheckbox extends Component {
	static propTypes = {
		error: PropTypes.bool,
		options: PropTypes.array,
		value: PropTypes.array,
		name: PropTypes.string.isRequired,
		maxChecked: PropTypes.number,
	};

	static defaultProps = {
		error: undefined,
		options: [],
		maxChecked: 0,
		value: [],
	};

	constructor(props) {
		super();

		this.state = {
			canCheck: props.maxChecked ? (props.maxChecked - this.value.length) > 0 : true,
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			this.props !== nextProps ||
			this.state.value !== nextState.value ||
			this.state.canCheck !== nextState.canCheck
		);
	}

	render() {
		let inputClassName = 'custom-checkbox__input';

		if (this.props.className) {
			labelClassName += ' ' + this.props.className;
		}

		if (this.props.error) {
			inputClassName += ' custom-checkbox__input--error';
		}

		return (
			<div className='custom-multicheckbox__container'>
				{this.props.options.map((opt, i) => <InputMultiCheckboxItem
					option={opt}
					checked={opt.checked || (this.props.value.indexOf(opt.id) !== -1) ? 1 : 0}
					canCheck={this.state.canCheck}
					onCheck={(e) => this.checkRemaining(e)}
					name={this.props.name}
					key={i}
					ref={'cb' + i}
				/>)}

				{/* print label if it exists. */}
				{this.props.children}
			</div>
		);
	}

	checkRemaining() {
		if (!this.props.maxChecked) {
			return true;
		}

		this.setState({
			...this.state,
			canCheck: (this.props.maxChecked - this.value.length) > 0,
		});
	}

	get value() {
		let values = [];

		if (this.refs) {
			let keys = Object.keys(this.refs);
			for (var i = 0; i < keys.length; i++) {
				let value = this.refs[keys[i]].value;
				if (value) {
					values.push(value);
				}
			}
		}

		return values;

		// ?test_name[]=11&test_name[]=22&test_name[]=33
	}

	set value(val) {}
}

class InputMultiCheckboxItem extends Component {
	static propTypes = {
		option: PropTypes.object.isRequired,
		checked: PropTypes.oneOf([1, 0, true, false]),
		name: PropTypes.string.isRequired,
		canCheck: PropTypes.bool,
	};

	static defaultProps = {
		canCheck: true,
	};

	constructor(props) {
		super();

		this.value = (props.checked || props.option.checked) ? props.option.id : false;

		this.state = {
			value: this.value,
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			this.props !== nextProps ||
			this.state.value !== nextState.value
		);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.checked !== nextProps.checked) {
			this.value = (nextProps.checked || nextProps.option.checked) ? nextProps.option.id : false;

			this.setState({
				...this.state,
				value: this.value,
			});
		}
	}

	render() {
		let labelClassName = 'span2 span4-tablet span7-mobile custom-checkbox custom-multicheckbox__item';
		let inputClassName = 'custom-checkbox__input';

		if (this.props.className) {
			labelClassName += ' ' + this.props.className;
		}

		if (this.props.error) {
			inputClassName += ' custom-checkbox__input--error';
		}

		if (!this.props.canCheck && !this.state.value) {
			labelClassName += ' custom-multicheckbox__item--blocked';
		}

		return (
			<label htmlFor={this.props.option.id} className={labelClassName}>
				<input
					ref='input'
					type='checkbox'
					id={this.props.option.id}
					name={this.props.name}
					onChange={this.onChange.bind(this)}
					className={inputClassName}
					checked={this.state.value}
				/>

				<div className='custom-checkbox__pseudo'></div>

				{this.props.option.label}
			</label>
		);
	}

	onChange(e) {
		if (e && e.target) {
			this.value = (e.target.checked && this.props.canCheck) ? this.props.option.id : false;
		}

		this.setState({
			...this.state,
			value: this.value,
		});

		this.props.onCheck(e);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/input/multicheckbox.js
 **/